import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { blogPath } from '../../lib/seo';
import { formatBlogDate } from '../../lib/blog';
export default function BlogCard({post}) {
  return <article className="ckr-card ckr-knowledge-card">
    <a href={blogPath(post)} className="ckr-knowledge-cover" aria-label={post.title}><img src={post.image} alt={post.imageAlt} width={post.imageWidth} height={post.imageHeight} loading="lazy" decoding="async" /></a>
    <div className="ckr-knowledge-card-body">
      <div className="ckr-knowledge-meta"><span>{post.category}</span>{post.publishedAt && <time dateTime={post.publishedAt}>{formatBlogDate(post.publishedAt)}</time>}</div>
      <h3><a href={blogPath(post)}>{post.title}</a></h3>
      <p>{post.excerpt}</p>
      <a href={blogPath(post)} className="ckr-knowledge-read">Yazıyı oku <ArrowUpRight size={16}/></a>
    </div>
  </article>;
}
